// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cashback from "../entity/Cashback.bs.js";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as CashbackApiModel from "../api-model/CashbackApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeApiModel(json) {
  return {
          slab: Cashback.getSlabFromString(json.cashback_slab),
          offered: Currency.toCurrency(json.cashback_offered),
          redeemed: Currency.toCurrency(json.cashback_redeemed),
          balance: Currency.toCurrency(json.cashback_balance)
        };
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(CashbackApiModel.t_decode(json), "CashbackEntityMapper.re"));
}

export {
  decodeApiModel ,
  execute ,
  
}
/* Cashback Not a pure module */
